<div class="coupon">
  <div class="title-area">
    <span class="title">
      <span>
        {{ couponCode.value | number: '1.0-0' }}
        {{ couponCode.discountType === 'fixed' ? '€' : '%' }}
      </span>
      <span> mehr </span>
    </span>
    <div class="actions-container">
      <div class="delete-button">
        <button class="circle-medium" (click)="onEditCoupon()">
          <div class="circle-icon">
            <i class="fa-regular fa-pen"></i>
          </div>
        </button>
      </div>
      <div class="delete-button">
        <button class="circle-medium" (click)="onDeleteCoupon()">
          <div class="circle-icon">
            <i class="fa-regular fa-trash-can"></i>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div class="info-area">
    <div class="coupon-content">
      <div class="flex-c gap-4">
        <div class="flex-r align-center gap-16">
          <p-toggleswitch
            class="flex-r"
            [(ngModel)]="couponCode.isActive"
            (onChange)="onCouponActiveStateChanged($event)">
          </p-toggleswitch>
          <div class="font-regular-title-large">
            {{ couponCode.title }}
          </div>
        </div>
        <span class="font-regular-body-large">
          {{ couponCode.description }}
        </span>
      </div>
      <div class="coupon-recipient-row">
        @if (couponCode.recipient) {
          <div class="flex-c gap-4">
            <span>Gesendet an:</span>
            <div class="promo-code">
              <span>
                {{ couponCode.recipient }}
              </span>
              <div class="copy-button">
                <i
                  class="fa-regular fa-copy"
                  (click)="copyToClipboard(couponCode.code)"></i>
              </div>
            </div>
          </div>
        }
        <div class="flex-c gap-4">
          <span>Code:</span>
          <div class="promo-code">
            <span>
              {{ couponCode.code }}
            </span>
            <div class="copy-button">
              <i
                class="fa-regular fa-copy"
                (click)="copyToClipboard(couponCode.code)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions-container">
      <button
        class="inwi-icon-text-button-medium-secondary"
        (click)="onEditCoupon()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-pen"></i>
          </div>
          <div class="button-text">Bearbeiten</div>
        </div>
      </button>
      <button
        class="inwi-icon-text-button-medium-secondary"
        (click)="onDeleteCoupon()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-trash-can"></i>
          </div>
          <div class="button-text">Löschen</div>
        </div>
      </button>
    </div>
  </div>
</div>
